import { FronteggContext } from '@frontegg/rest-api';
import { Axios, AxiosAmbient } from 'src/lib';
import {
  ehrCorelationContext,
  ehrCorelationStatus,
  ehrSubmitDocument,
  ehrSubmitDocumentStatus,
} from '../slices/ehr';
import { getErrorCode } from 'src/store';

export const getEHRCorelationContext = (data) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };

    try {
      const result = await Axios.post(`/ehr/corelate`, data, { headers });
      const response = result?.data;

      if (result?.status === 200) {
        dispatch(ehrCorelationStatus('success'));
        dispatch(ehrCorelationContext(response));
      } else {
        dispatch(ehrCorelationStatus('error'));
      }
    } catch (error) {
      // const response = error.response?.data;
      dispatch(ehrCorelationStatus('error'));
    }
  };
};

export const submitDocumentToEHRIntegration = (data) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    dispatch(ehrSubmitDocumentStatus('loading'));
    dispatch(ehrSubmitDocument(null));
    try {
      const result = await AxiosAmbient.post(`/ehr/document`, data, {
        headers,
      });
      const response = result?.data;

      if (result?.status === 200 && response) {
        dispatch(ehrSubmitDocument(response));
        dispatch(ehrSubmitDocumentStatus('success'));
      }
    } catch (error) {
      dispatch(ehrSubmitDocumentStatus('error'));
      getErrorCode(500);
    }
  };
};
